import { render, staticRenderFns } from "./MainRegistration.vue?vue&type=template&id=612392ee&scoped=true"
import script from "./MainRegistration.vue?vue&type=script&lang=js"
export * from "./MainRegistration.vue?vue&type=script&lang=js"
import style0 from "./MainRegistration.vue?vue&type=style&index=0&id=612392ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612392ee",
  null
  
)

export default component.exports